
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class IntroBlock extends Vue {
  @Prop(Object)
  block!: any;

  get link(): string | undefined {
    return this.block.button_link || undefined;
  }
}
